module.exports = __webpack_public_path__ + "img/1-circle.c2ae181b.png";